export const iconFontAwesomeCommunicationFaceMeh = (
	<i className="fa-solid fa-face-meh"></i>
);
